import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";

let PrivacyNoticeViewComponent = {
    selector: "vcPrivacyNoticeView",
    templateUrl:
        "/angular/components/privacy/privacy-notice-view.component.html",
    bindings: {
        privacyNotice: "=?",
    },
    controller: class PrivacyNoticeViewController {
        // * bindings for typescript compiler *
        public privacyNotice?: any;
        // ************************************

        private dialog: DialogUtils;

        constructor(DialogUtils: DialogUtils) {
            this.dialog = DialogUtils;
        }

        close(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("privacy")
    .component(PrivacyNoticeViewComponent.selector, PrivacyNoticeViewComponent);
